import type { ReactNode } from "react";

// The one sentence a staff member reads where the customer's page would let the customer change something and the
// staff view only looks (docs/features/customer-portal-view-as/11_everything_visible_read_only.md). Each page says what
// it cannot do; this draws it the same way everywhere. Provisional wording (docs/ui-wording.md).

/** Where a page's change is one staff make by switching on "Act for…". */
export const ACT_FOR_TO_CHECK_ARTWORK =
  "You're looking at this page as the customer sees it. To check a file for the customer, choose Act for… above.";

/** The same page for a caller who cannot act for this target (a preview, or no permit). */
export const NO_ARTWORK_CHECK_WHEN_LOOKING =
  "You're looking at this page as the customer sees it. A file can't be checked from here.";

/** Where the page offers no change to staff at all, acting or not: the customer's basket is theirs to fill. */
export const STAFF_VIEW_NO_ADD_TO_BASKET =
  "You're looking at this product as the customer sees it. It can't be added to a basket from here.";

export function StaffViewReadOnlyNote({ children }: { children: ReactNode }) {
  return (
    <p
      role="note"
      className="rounded-md border border-dashed bg-muted/40 px-3 py-2 text-sm text-muted-foreground"
    >
      {children}
    </p>
  );
}
